// Plate lightbox: a link marked data-lightbox (the full-width feature
// image on Photo posts) opens the linked original in the page's
// <dialog class="gh-lightbox"> instead of navigating. Click anywhere or
// press Escape to close. The original file is only fetched on open.
export default function lightbox() {
    const dialog = document.querySelector(".gh-lightbox");
    const links = document.querySelectorAll("a[data-lightbox]");
    if (!dialog || !links.length || typeof dialog.showModal !== "function") return;

    const img = dialog.querySelector("img");

    links.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const alt = link.querySelector("img");
            img.alt = alt ? alt.alt : "";
            img.src = link.href;
            dialog.showModal();
            document.documentElement.classList.add("gh-lightbox-open");
        });
    });

    dialog.addEventListener("click", () => dialog.close());
    dialog.addEventListener("close", () => {
        document.documentElement.classList.remove("gh-lightbox-open");
        img.removeAttribute("src");   // free the large image
    });
}
